import AbstractCustomerValueModel from '../abstract_customer_value_model';
import BenefitsChartValue from '../../charts/benefits_chart_value';
import BenefitsWaterfallChart from '../../charts/symplr/pdm/benefits_waterfall_chart';

class SymplrPdm extends AbstractCustomerValueModel {
  custom_chart_classes() {
    return { BenefitsChartValue, BenefitsWaterfallChart };
  }

  percent_rdxn_time_credentialing() {
    return this.input.percent_rdxn_time_credentialing / 100;
  }

  percent_rdxn_time_committee_mtg() {
    return this.input.percent_rdxn_time_committee_mtg / 100;
  }

  percent_rdxn_time_enrolling_providers() {
    return this.input.percent_rdxn_time_enrolling_providers / 100;
  }

  percent_rdxn_time_adding_to_ehr() {
    return this.input.percent_rdxn_time_adding_to_ehr / 100;
  }

  percent_rdxn_call_volume() {
    return this.input.percent_rdxn_call_volume / 100;
  }

  percent_rdxn_credentialing_timeline() {
    return this.input.percent_rdxn_credentialing_timeline / 100;
  }

  percent_imprv_operating_margin_pt_acquisition() {
    return this.input.percent_imprv_operating_margin_pt_acquisition / 100;
  }

  percent_imprv_operating_margin_pt_leakage() {
    return this.input.percent_imprv_operating_margin_pt_leakage / 100;
  }

  adoption_rate_year_1() {
    return this.input.adoption_rate_year_1 / 100;
  }

  adoption_rate_year_2() {
    return this.input.adoption_rate_year_2 / 100;
  }

  adoption_rate_year_3() {
    return this.input.adoption_rate_year_3 / 100;
  }

  adoption_rate_year_4() {
    return this.input.adoption_rate_year_4 / 100;
  }

  adoption_rate_year_5() {
    return this.input.adoption_rate_year_5 / 100;
  }

  adoption_rate(year) {
    switch (year) {
      case 1: return this.adoption_rate_year_1();
      case 2: return this.adoption_rate_year_2();
      case 3: return this.adoption_rate_year_3();
      case 4: return this.adoption_rate_year_4();
      case 5: return this.adoption_rate_year_5();
      default: return 1.0;
    }
  }

  annual_committee_member_salary() {
    return this.input.annual_committee_member_salary;
  }

  annual_med_staff_salary() {
    return this.input.annual_med_staff_salary;
  }

  annual_price_increase(year) {
    return (1 + (this.input.annual_increase / 100)) ** (year - 1);
  }

  avg_credentialing_time() {
    return this.input.avg_credentialing_time;
  }

  avg_daily_variable_cost() {
    return 20 / 100;
  }

  burden_rate() {
    return this.input.burden_rate;
  }

  calls_per_year() {
    return this.input.calls_per_year;
  }

  cost_per_call() {
    return this.input.cost_per_call;
  }

  daily_revenue_per_provider() {
    return this.input.daily_revenue_per_provider;
  }

  directory_implementation_fee() {
    if (this.product_directory() === 0) { return 0; }

    return this.input.directory_implementation_fee;
  }

  directory_license_fee() {
    if (this.product_directory() === 0) { return 0; }

    return this.input.directory_license_fee;
  }

  employed_providers() {
    return this.input.employed_providers;
  }

  fte_in_committee_mtg() {
    return this.input.fte_in_committee_mtg;
  }

  fully_burdened_salary(salary) {
    return salary * this.burden_rate();
  }

  hospitals_in_system() {
    return this.input.hospitals_in_system;
  }

  hours_per_year() {
    return 1880;
  }

  hr_enrolling_providers() {
    return this.input.hr_enrolling_providers;
  }

  hr_in_committee_mtg() {
    return this.input.hr_in_committee_mtg;
  }

  med_staff_ftes() {
    return this.input.med_staff_ftes;
  }

  min_adding_to_ehr() {
    return this.input.min_adding_to_ehr;
  }

  net_operating_profit_margin() {
    return this.input.net_operating_profit_margin / 100;
  }

  net_pt_revenue() {
    return this.input.net_pt_revenue;
  }

  outpt_visits_per_year() {
    return this.input.outpt_visits_per_year;
  }

  product_directory() {
    return this.input.product_directory;
  }

  provider_implementation_fee() {
    if (this.product_provider() === 0) { return 0; }

    return this.input.provider_implementation_fee;
  }

  provider_license_fee() {
    if (this.product_provider() === 0) { return 0; }

    return this.input.provider_license_fee;
  }

  product_provider() {
    return this.input.product_provider;
  }

  providers_added_per_yr() {
    return this.input.providers_added_per_yr;
  }

  providers_credentialed_per_month() {
    return this.input.providers_credentialed_per_month;
  }

  pt_discharges_per_year() {
    return this.input.pt_discharges_per_year;
  }

  time_on_credentialing() {
    return this.input.time_on_credentialing;
  }

  time_preparing_for_mtg() {
    return this.input.time_preparing_for_mtg;
  }

  weeks_per_year() {
    return 50;
  }

  // Benefit 1
  reduce_time_credentialing() {
    if (this.product_provider() === 0) { return 0; }
    console.log(this.med_staff_ftes())

    // =H9*(H12/Configurator!$G$50)*Configurator!$G$48*'Benefit Calculations'!H11
    return this.time_on_credentialing()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.weeks_per_year() * this.med_staff_ftes()
      * this.percent_rdxn_time_credentialing();
  }

  // Benefit 2
  reduce_time_committee_review() {
    if (this.product_provider() === 0) { return 0; }

    // =H26*(H30/Configurator!$G$50)*12*H28*H29
    const time_spent_in_mtg = this.hr_in_committee_mtg()
      * (this.fully_burdened_salary(this.annual_committee_member_salary()) / this.hours_per_year())
    * 12 * this.fte_in_committee_mtg() * this.hospitals_in_system()
      * this.percent_rdxn_time_committee_mtg();

    // =H33*(H36/Configurator!$G$50)*12*'Benefit Calculations'!H35
    const time_spent_preparing = this.time_preparing_for_mtg()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * 12 * this.med_staff_ftes()
      * this.percent_rdxn_time_committee_mtg();

    return time_spent_in_mtg + time_spent_preparing;
  }

  // Benefit 3
  reduce_time_enrolling_providers() {
    if (this.product_provider() === 0) { return 0; }

    // =H49*(H52/Configurator!$G$50)*Configurator!$G$48*'Benefit Calculations'!H51
    return this.hr_enrolling_providers()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.weeks_per_year() * this.med_staff_ftes()
      * this.percent_rdxn_time_enrolling_providers();
  }

  // Benefit 4
  reduce_time_adding_to_ehr() {
    if (this.product_directory() === 0) { return 0; }

    // =(H64)*(H67/Configurator!$G$50)*'Benefit Calculations'!H66
    return this.min_adding_to_ehr()
      * (this.fully_burdened_salary(this.annual_med_staff_salary()) / this.hours_per_year())
    * this.providers_added_per_yr()
      * this.percent_rdxn_time_adding_to_ehr();
  }

  // Benefit 5
  reduce_call_volume() {
    if (this.product_directory() === 0) { return 0; }

    // =H79*H81
    return this.calls_per_year() * this.cost_per_call()
      * this.percent_rdxn_call_volume();
  }

  // Benefit 6
  increase_revenue() {
    if (this.product_provider() === 0) { return 0; }

    // =(H120*H122*H123*(1-H124))
    return (this.avg_credentialing_time() * this.daily_revenue_per_provider() * this.providers_credentialed_per_month())
      * (1 - this.avg_daily_variable_cost())
    * this.percent_rdxn_credentialing_timeline();
  }

  // Benefit 7
  improve_pt_acquisition() {
    if (this.product_directory() === 0) { return 0; }

    // =H137*H138
    return this.net_pt_revenue() * this.percent_imprv_operating_margin_pt_acquisition();
  }

  // Benefit 8
  reduce_pt_leakage() {
    if (this.product_directory() === 0) { return 0; }

    // =H151*H152
    return this.net_pt_revenue() * this.percent_imprv_operating_margin_pt_leakage();
  }

  all_benefits() {
    return [
      'reduce_time_credentialing',
      'reduce_time_committee_review',
      'reduce_time_enrolling_providers',
      'reduce_time_adding_to_ehr',
      'reduce_call_volume',
      'increase_revenue',
      'improve_pt_acquisition',
      'reduce_pt_leakage'
    ];
  }

  value_drivers() {
    return [
      'streamline_healthcare_operations',
      'grow_protect_revenue'
    ];
  }

  streamline_healthcare_operations() {
    return this.reduce_time_credentialing()
      + this.reduce_time_committee_review()
      + this.reduce_time_enrolling_providers()
      + this.reduce_time_adding_to_ehr()
      + this.reduce_call_volume();
  }

  grow_protect_revenue() {
    return this.increase_revenue()
      + this.improve_pt_acquisition()
      + this.reduce_pt_leakage();
  }

  total_annual_investment(year = 1) {
    let cost = 0;

    if (this.product_provider() === 1) {
      cost += this.provider_license_fee();
      if (year === 1) {
        cost += this.provider_implementation_fee();
      }
    }

    if (this.product_directory() === 1) {
      cost += this.directory_license_fee();
      if (year === 1) {
        cost += this.directory_implementation_fee();
      }
    }

    return cost * this.annual_price_increase(year);
  }

  streamline_healthcare_operations_label() {
    return this.input.streamline_healthcare_operations_label;
  }

  grow_protect_revenue_label() {
    return this.input.grow_protect_revenue_label;
  }

  reduce_time_credentialing_label() {
    return this.input.reduce_time_credentialing_label;
  }

  reduce_time_committee_review_label() {
    return this.input.reduce_time_committee_review_label;
  }

  reduce_time_enrolling_providers_label() {
    return this.input.reduce_time_enrolling_providers_label;
  }

  reduce_time_adding_to_ehr_label() {
    return this.input.reduce_time_adding_to_ehr_label;
  }

  reduce_call_volume_label() {
    return this.input.reduce_call_volume_label;
  }

  increase_revenue_label() {
    return this.input.increase_revenue_label;
  }

  improve_pt_acquisition_label() {
    return this.input.improve_pt_acquisition_label;
  }

  reduce_pt_leakage_label() {
    return this.input.reduce_pt_leakage_label;
  }
}

export default SymplrPdm;
